<div class="container-fluid">
    <div class="row">
      <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 class="mb-sm-0">System Users</h4>

              <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
                      <li class="breadcrumb-item active">System User Details</li>
                  </ol>
              </div>

          </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
          <div class="card">
              <div class="card-header align-items-center d-flex">
                  <h4 class="card-title mb-0 flex-grow-1">System User Details</h4>
                  <div class="flex-shrink-0">
                      <a [routerLink]="['/system-user/edit', systemUserId]"><button type="button" class="btn btn-primary">Edit System User</button></a>
                  </div>
              </div>
              <div class="card-body">
                  <div class="live-preview">
                      <div class="row gy-4">
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="firstName" class="form-label">First Name</label>
                                  <input type="text" class="form-control" id="firstName" [(ngModel)]="systemUser.first_name" [ngClass]="{'is-invalid': !systemUser.first_name && validationTriggered, 'is-valid': validationTriggered && systemUser.first_name}" disabled>
                              </div>
                          </div>
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="lastName" class="form-label">Last Name</label>
                                  <input type="text" class="form-control" id="lastName" [(ngModel)]="systemUser.last_name" [ngClass]="{'is-invalid': !systemUser.last_name && validationTriggered, 'is-valid': validationTriggered && systemUser.last_name}" disabled>
                              </div>
                          </div>
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="email" class="form-label">Email</label>
                                  <input type="email" class="form-control" id="email" [(ngModel)]="systemUser.email" [ngClass]="{'is-invalid': (!systemUser.email && validationTriggered) || (validationTriggered && !isValidEmail(systemUser.email)), 'is-valid': validationTriggered && systemUser.email && isValidEmail(systemUser.email)}" disabled>
                              </div>
                          </div>
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="mobileNumber" class="form-label">Mobile Number</label>
                                  <input type="text" class="form-control" id="mobileNumber" [(ngModel)]="systemUser.mobile_number" [ngClass]="{'is-invalid': !systemUser.mobile_number && validationTriggered, 'is-valid': validationTriggered && systemUser.mobile_number}" disabled>
                              </div>
                          </div>
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="roleSelect" class="form-label">Role</label>
                                  <select class="form-select" id="roleSelect" [(ngModel)]="systemUser.id_role" [ngClass]="{'is-valid': validationTriggered}" disabled>
                                      <option value="1">Admin</option>
                                  </select>
                              </div>
                          </div>
                          <div class="col-xxl-6 col-md-6">
                              <div>
                                  <label for="statusSelect" class="form-label">Status</label>
                                  <select class="form-select" id="statusSelect" [(ngModel)]="systemUser.status" [ngClass]="{'is-valid': validationTriggered}" disabled>
                                      <option value="1">Active</option>
                                      <option value="2">Inactive</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      </div>
  </div>